module.exports = __webpack_public_path__ + "static/media/cloud-sun.1219d93e.svg";